import { ValidationError } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/ValidatorError';
import { Validator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/Validator';
export class PaymentStateViewModelValidator extends Validator {
    validate(model) {
        const validationErrors = [];
        // 1. Validar SetConfigurationData (referenceId, items)
        this.validateConfigurationData(model, validationErrors);
        // 2. Validar SetCustomizeData (textBody)
        this.validateCustomizeData(model, validationErrors);
        // 3. Validar SetPaymentMethodData (pelo menos 1 método configurado)
        this.validatePaymentMethodData(model, validationErrors);
        if (validationErrors.length > 0) {
            model.$invalid = true;
            throw new ValidationError(`One or more validation errors occurred: ${validationErrors
                .map((e) => e.message)
                .join(', ')}`);
        }
    }
    validateConfigurationData(model, validationErrors) {
        const configAction = model.$leavingCustomActions?.find((action) => action.$title === 'SetConfigurationData');
        if (!configAction || !configAction.settings) {
            validationErrors.push(new ValidationError('Payment configuration is missing'));
            return;
        }
        const configValue = configAction.settings.value;
        if (!configValue || configValue === '{}') {
            validationErrors.push(new ValidationError('Payment configuration data is required'));
            return;
        }
        try {
            const configData = JSON.parse(configValue);
            // Validar referenceId
            if (!configData.referenceId || configData.referenceId.trim() === '') {
                validationErrors.push(new ValidationError('Reference ID is required in payment configuration'));
            }
            // Validar items
            if (!configData.items || configData.items.trim() === '') {
                validationErrors.push(new ValidationError('At least one item is required in payment configuration'));
            }
        }
        catch (error) {
            validationErrors.push(new ValidationError('Invalid payment configuration format'));
        }
    }
    validateCustomizeData(model, validationErrors) {
        const customizeAction = model.$leavingCustomActions?.find((action) => action.$title === 'SetCustomizeData');
        if (!customizeAction || !customizeAction.settings) {
            validationErrors.push(new ValidationError('Payment customization data is missing'));
            return;
        }
        const customizeValue = customizeAction.settings.value;
        if (!customizeValue || customizeValue === '{}') {
            validationErrors.push(new ValidationError('Body text is required in payment configuration'));
            return;
        }
        try {
            const customizeData = JSON.parse(customizeValue);
            // Validar textBody
            if (!customizeData.textBody || customizeData.textBody.trim() === '') {
                validationErrors.push(new ValidationError('Body text is required in payment configuration'));
            }
        }
        catch (error) {
            validationErrors.push(new ValidationError('Invalid payment customization format'));
        }
    }
    validatePaymentMethodData(model, validationErrors) {
        const paymentMethodAction = model.$leavingCustomActions?.find((action) => action.$title === 'SetPaymentMethodData');
        if (!paymentMethodAction || !paymentMethodAction.settings) {
            validationErrors.push(new ValidationError('Payment method data is missing'));
            return;
        }
        const paymentMethodValue = paymentMethodAction.settings.value;
        if (!paymentMethodValue || paymentMethodValue === '{}') {
            validationErrors.push(new ValidationError('At least one payment method must be configured'));
            return;
        }
        try {
            const paymentData = JSON.parse(paymentMethodValue);
            // Verificar se o método 2 está ativado
            const isMethod2Enabled = paymentData.showMethod2 === true;
            // Verificar se pelo menos um método está configurado
            const hasMethod1 = paymentData.method1 && paymentData.method1.type;
            const hasMethod2 = paymentData.method2 && paymentData.method2.type;
            if (!hasMethod1 && !hasMethod2) {
                validationErrors.push(new ValidationError('At least one payment method must be configured'));
                return;
            }
            // Validar método 1 (sempre obrigatório se estiver configurado)
            if (hasMethod1) {
                this.validatePaymentMethod(paymentData.method1, 'Method 1', validationErrors);
            }
            // Validar método 2 SOMENTE se estiver ativado (showMethod2 = true)
            if (isMethod2Enabled && hasMethod2) {
                this.validatePaymentMethod(paymentData.method2, 'Method 2', validationErrors);
            }
        }
        catch (error) {
            validationErrors.push(new ValidationError('Invalid payment method format'));
        }
    }
    validatePaymentMethod(method, methodName, validationErrors) {
        if (!method.config) {
            validationErrors.push(new ValidationError(`${methodName}: Configuration is missing`));
            return;
        }
        const config = method.config;
        // Validação específica por tipo de método
        switch (method.type) {
            case 'pixcopycode':
                if (!config.business || config.business.trim() === '') {
                    validationErrors.push(new ValidationError(`${methodName} (PIX): Business name is required`));
                }
                if (!config.keyType || config.keyType.trim() === '') {
                    validationErrors.push(new ValidationError(`${methodName} (PIX): Key type is required`));
                }
                if (!config.pixKey || config.pixKey.trim() === '') {
                    validationErrors.push(new ValidationError(`${methodName} (PIX): PIX key is required`));
                }
                if (!config.pixCode || config.pixCode.trim() === '') {
                    validationErrors.push(new ValidationError(`${methodName} (PIX): PIX code is required`));
                }
                break;
            case 'barcode':
                if (!config.boletoCode || config.boletoCode.trim() === '') {
                    validationErrors.push(new ValidationError(`${methodName} (Boleto): Boleto code is required`));
                }
                break;
            case 'paymentlink':
                if (!config.httpsLink || config.httpsLink.trim() === '') {
                    validationErrors.push(new ValidationError(`${methodName} (Payment Link): HTTPS link is required`));
                }
                break;
        }
    }
}
